import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const stats = [
  { value: "4600+", label: "圈内速递" },
  { value: "12 小时", label: "热点响应" },
  { value: "4 大栏目", label: "全维度覆盖" },
];

export default function Hero() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const term = q.trim();
    navigate(term ? `/search?q=${encodeURIComponent(term)}` : "/#feed");
  };

  return (
    <section className="relative flex min-h-[560px] items-center overflow-hidden md:min-h-[640px]">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20entertainment%20background%20with%20vibrant%20stage%20spotlights%20and%20bokeh%20particles%20in%20warm%20orange%20amber%20and%20deep%20rose%20tones%2C%20glittering%20cinematic%20glow%2C%20artistic%20magazine%20cover%20style%2C%20dreamy%20atmosphere&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="娱乐圈动态舞台灯光背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/40 to-foreground-950/70"></div>
      </div>

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 py-20 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-1.5 text-xs font-medium text-background-50 ring-1 ring-inset ring-background-50/30 backdrop-blur">
          <i className="ri-flashlight-fill text-accent-300" />
          今日圈内热点持续更新中
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
          娱乐圈新鲜事
          <span className="mt-1 block bg-gradient-to-r from-accent-300 to-primary-300 bg-clip-text text-transparent">
            追星吃瓜一站搞定
          </span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-6 text-background-100/90 md:text-base">
          吃瓜视频网聚焦娱乐八卦与圈内速递，汇集明星动态、综艺片段、影视花絮及红人视频，实时更新圈内动态，让你轻松掌握娱乐圈最新热点。
        </p>

        <form
          onSubmit={submit}
          className="mx-auto mt-8 flex w-full max-w-xl flex-col items-center gap-2 rounded-full bg-background-50 p-1.5 sm:flex-row"
          role="search"
        >
          <div className="flex w-full flex-1 items-center gap-2 px-3">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="search"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="搜索你关心的明星、综艺、影视…"
              className="w-full bg-transparent py-2 text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              aria-label="搜索圈内动态"
            />
          </div>
          <button
            type="submit"
            className="w-full whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:w-auto"
          >
            开始吃瓜
          </button>
        </form>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <a
            href="#feed"
            className="inline-flex items-center gap-2 rounded-full bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-900 transition hover:bg-accent-400 hover:text-background-50"
          >
            <i className="ri-video-line" /> 看今日速递
          </a>
          <Link
            to="/columns/stars"
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium text-background-50 ring-1 ring-inset ring-background-50/40 transition hover:bg-background-50/10"
          >
            <i className="ri-compass-line" /> 浏览栏目
          </Link>
        </div>

        <dl className="mx-auto mt-10 grid max-w-lg grid-cols-3 gap-4">
          {stats.map((s) => (
            <div key={s.label} className="rounded-xl bg-background-50/10 px-3 py-3 ring-1 ring-inset ring-background-50/20 backdrop-blur">
              <dt className="font-heading text-xl font-bold text-background-50 md:text-2xl">{s.value}</dt>
              <dd className="mt-1 text-xs text-background-100/80">{s.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}